import { render, staticRenderFns } from "./notification_types.vue?vue&type=template&id=d3d84316&scoped=true&"
import script from "./notification_types.vue?vue&type=script&lang=js&"
export * from "./notification_types.vue?vue&type=script&lang=js&"
import style0 from "./notification_types.vue?vue&type=style&index=0&id=d3d84316&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d3d84316",
  null
  
)

export default component.exports